import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { Loading } from '@ibk/shared-ui';
const RenderClientCenterHeaderRight = React.lazy(async () => {
    try {
        const clientCenterHeaderRight = await import('clientcenter/ClientCenterHeaderRight');
        return clientCenterHeaderRight;
    }
    catch (err) {
        console.error('[ClientCenterHeaderRight] remote component failed to load:', err);
        return { default: () => null };
    }
});
export function ClientCenterHeaderRightWrapper() {
    return (_jsx(Suspense, { fallback: _jsx(Loading, { size: 'small' }), children: _jsx(RenderClientCenterHeaderRight, {}) }));
}
